import { render, staticRenderFns } from "./ListBunchesAreas.vue?vue&type=template&id=2350b76c"
import script from "./ListBunchesAreas.vue?vue&type=script&lang=js"
export * from "./ListBunchesAreas.vue?vue&type=script&lang=js"
import style0 from "./ListBunchesAreas.vue?vue&type=style&index=0&id=2350b76c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2350b76c')) {
      api.createRecord('2350b76c', component.options)
    } else {
      api.reload('2350b76c', component.options)
    }
    module.hot.accept("./ListBunchesAreas.vue?vue&type=template&id=2350b76c", function () {
      api.rerender('2350b76c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ListBunchesAreas.vue"
export default component.exports